/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

// Polyfill for Node.js globals required by some libraries.
// Kept in a module instead of an inline <script> so that the Content-Security-Policy
// can forbid inline scripts entirely.
const processShim = {
    env: {},
    browser: true,
    cwd: function () {
        return "/";
    },
    nextTick: function (fn) {
        setTimeout(fn, 0);
    },
};

// bundled deps (vfile, used by react-markdown) may define a partial `process`
// before this module runs, so fill in what is missing instead of replacing it
window.process = window.process || {};
Object.keys(processShim).forEach((key) => {
    if (window.process[key] === undefined) {
        window.process[key] = processShim[key];
    }
});

window.global = window.global || window;
